import { motion, AnimatePresence } from "framer-motion";
import { useEffect } from "react";
import { FaLinkedinIn, FaFacebookF, FaInstagram } from "react-icons/fa";

import founderImage from "../assets/VA-Founder-Regine Candido.jpg";

export default function Owner({ isOpen, onClose }) {

  useEffect(() => {
    document.body.style.overflow = isOpen ? "hidden" : "auto";
  }, [isOpen]);

  const howItWorks = [
    "Discovery & Strategy Alignment",
    "System Integration & Setup",
    "Dedicated VA Assignment",
    "Ongoing Optimization & Growth"
  ];

  return (
    <AnimatePresence>
      {isOpen && (
        <>
          {/* OVERLAY */}
          <motion.div
            className="fixed inset-0 z-50 bg-black/70 backdrop-blur-sm"
            onClick={onClose}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          />

          {/* MODAL */}
          <motion.div
            initial={{ opacity: 0, scale: 0.92, x: "-50%", y: "-50%" }}
            animate={{ opacity: 1, scale: 1, x: "-50%", y: "-50%" }}
            exit={{ opacity: 0, scale: 0.92 }}
            transition={{ duration: 0.35 }}
            className="fixed z-50 top-1/2 left-1/2
                       w-[95%] md:w-[90%] lg:w-[75%]
                       max-h-[90vh]
                       rounded-3xl
                       bg-white/70 backdrop-blur-2xl
                       border border-neutral-border
                       shadow-soft
                       overflow-hidden flex flex-col"
          >

            <div className="absolute -inset-1 bg-accent/5 blur-2xl rounded-3xl -z-10" />

            {/* HEADER */}
            <div className="flex items-center justify-between px-6 py-5 border-b border-neutral-border">
              <h2 className="font-heading text-xl md:text-2xl text-primary">
                The Story Behind Rcreate
              </h2>
              <button
                onClick={onClose}
                className="text-accent text-2xl hover:scale-110 transition"
              >
                ✕
              </button>
            </div>

            {/* CONTENT */}
            <div className="p-8 overflow-y-auto">
              <div className="grid md:grid-cols-2 gap-14">

                {/* LEFT */}
                <div className="space-y-12">

                  {/* FOUNDER */}
                  <section className="flex flex-col items-center text-center space-y-5">
                    <div className="relative w-36 h-36 rounded-full overflow-hidden shadow-premium border border-neutral-border">
                      <img
                        src={founderImage}
                        alt="Founder & CEO"
                        className="w-full h-full object-cover"
                      />
                    </div>

                    <h3 className="font-heading text-2xl text-accent">
                      Founder & CEO
                    </h3>

                    <p className="font-semibold text-primary">
                      Ms. REGINE S. CANDIDO
                    </p>

                    <p className="font-body text-neutral-muted leading-relaxed text-sm max-w-md">
                      Rcreate was built to empower business owners with
                      structured systems, strategic marketing foundations,
                      and operational clarity that supports sustainable growth.
                    </p>

                    {/* SOCIALS */}
                    <div className="flex gap-4 pt-3">

                      <motion.a
                        href="https://www.linkedin.com/company/rcreate-virtual-assistance-services/?viewAsMember=true"
                        target="_blank"
                        rel="noopener noreferrer"
                        whileHover={{ scale: 1.1 }}
                        className="w-10 h-10 rounded-full bg-white/60 backdrop-blur-xl border border-neutral-border flex items-center justify-center text-primary hover:text-accent transition"
                      >
                        <FaLinkedinIn size={14} />
                      </motion.a>

                      <motion.a
                        href="https://www.facebook.com/rcreatevaservices"
                        target="_blank"
                        rel="noopener noreferrer"
                        whileHover={{ scale: 1.1 }}
                        className="w-10 h-10 rounded-full bg-white/60 backdrop-blur-xl border border-neutral-border flex items-center justify-center text-primary hover:text-accent transition"
                      >
                        <FaFacebookF size={14} />
                      </motion.a>

                      <motion.a
                        href="https://www.instagram.com/rcreatevaservices/"
                        target="_blank"
                        rel="noopener noreferrer"
                        whileHover={{ scale: 1.1 }}
                        className="w-10 h-10 rounded-full bg-white/60 backdrop-blur-xl border border-neutral-border flex items-center justify-center text-primary hover:text-accent transition"
                      >
                        <FaInstagram size={14} />
                      </motion.a>

                    </div>
                  </section>

                  {/* JOURNEY */}
                  <section className="space-y-6">
                    <h4 className="font-heading text-xl text-primary">
                      Our Journey
                    </h4>

                    <div className="space-y-6 border-l-2 border-accent/40 pl-6">
                      {[
                        { year: "2021", text: "The idea was born — structured virtual support for growing businesses." },
                        { year: "2022", text: "Launched with a focused team committed to excellence." },
                        { year: "2023", text: "Expanded into marketing systems and website development." },
                        { year: "Today", text: "Building scalable systems for founders worldwide." }
                      ].map((item, i) => (
                        <motion.div key={i}>
                          <h5 className="font-semibold text-primary">{item.year}</h5>
                          <p className="text-neutral-muted text-sm">{item.text}</p>
                        </motion.div>
                      ))}
                    </div>
                  </section>

                  <p className="italic text-accent">
                    “Strong systems create sustainable success.”
                  </p>

                </div>

                {/* RIGHT */}
                <div className="space-y-12">

                  {/* HOW IT WORKS */}
                  <section>
                    <h4 className="font-heading text-xl text-primary mb-6">
                      How It Works
                    </h4>

                    <div className="space-y-4">
                      {howItWorks.map((step, i) => (
                        <div key={i} className="bg-white/60 rounded-xl p-4 text-sm text-neutral-muted">
                          {step}
                        </div>
                      ))}
                    </div>
                  </section>

                </div> {/* ✅ FIX: closed RIGHT column */}

              </div> {/* grid */}
            </div> {/* content */}

          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
}